import React, { useRef, Fragment } from 'react';
import { Carousel } from 'antd';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './FeatureCarousel.module.scss';

const FeatureCarousel = () => {
  const sliderMobile = useRef(null);
  const sliderDesktop = useRef(null);
  return (
    <div style={{ backgroundColor: '#f6f9fc', padding: '50px 0' }}>
      <div className={styles.Container}>
        <h2>Feature List</h2>
        <>
          <div className={styles.MobileOnly}>
            <Carousel autoplay dots="false" ref={sliderMobile}>
              <div className={styles.FeatureSlide}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <div className={styles.Feature}>
                    <img src="/img/icons/chat.svg" alt="Feature" />
                    <h3>Event Chats</h3>
                    <p>
                      Interact with other attendees before and during the event
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/form.svg" alt="Feature" />
                    <h3>Google Forms</h3>
                    <p>
                      Seamlessly integrate Google Forms directly into the
                      checkout flow
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/ticket.svg" alt="Feature" />
                    <h3>Flexible Ticket Pricing</h3>
                    <p>
                      Set up to 100 additional tiers, public or password
                      protected
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/qr.svg" alt="Feature" />
                    <h3>QR Code Tickets & Scanning</h3>
                    <p>Keep track of guest attendance for your event</p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/guest.svg" alt="Feature" />
                    <h3>Guest Engagement Tools</h3>
                    <p>
                      Text or email all attendees with updates simultaneously
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/event.svg" alt="Feature" />
                    <h3>Event Transparency</h3>
                    <p>
                      Itemized Excel sheets for guest details and financial
                      management
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/sponsor.svg" alt="Feature" />
                    <h3>Event Sponsorship</h3>
                    <p>
                      Work with Bounce’s corporate partners for food, drinks,
                      and custom swag
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/cohost.svg" alt="Feature" />
                    <h3>Co-Hosts & Operators</h3>
                    <p>
                      Add other event organizers to help manage and run your
                      event
                    </p>
                  </div>
                </div>
              </div>
            </Carousel>
            <div className={styles.Arrows}>
              <div className={styles.Arrow}>
                <FontAwesomeIcon
                  icon={faAngleLeft}
                  onClick={() => sliderMobile.current.prev()}
                  size="2x"
                />
              </div>
              <div className={styles.Arrow}>
                <FontAwesomeIcon
                  icon={faAngleRight}
                  onClick={() => sliderMobile.current.next()}
                  size="2x"
                />
              </div>
            </div>
          </div>
        </>

        <>
          <div className={styles.DesktopOnly}>
            <Carousel autoplay dots="false" ref={sliderDesktop}>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/chat.svg" alt="Feature" />
                    <h3>Event Chats</h3>
                    <p>
                      Interact with other attendees before and during the event
                    </p>
                  </div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/form.svg" alt="Feature" />
                    <h3>Google Forms</h3>
                    <p>
                      Seamlessly integrate Google Forms directly into the
                      checkout flow
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/ticket.svg" alt="Feature" />
                    <h3>Flexible Ticket Pricing</h3>
                    <p>
                      Set up to 4 additional tiers, public or password protected
                    </p>
                  </div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/qr.svg" alt="Feature" />
                    <h3>QR Code Tickets & Scanning</h3>
                    <p>Keep track of guest attendance for your event</p>
                  </div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/guest.svg" alt="Feature" />
                    <h3>Guest Engagement Tools</h3>
                    <p>
                      Text or email all attendees with updates simultaneously
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.FeatureSlide}>
                <div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/event.svg" alt="Feature" />
                    <h3>Event Transparency</h3>
                    <p>
                      Itemized Excel sheets for guest details and financial
                      management
                    </p>
                  </div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/sponsor.svg" alt="Feature" />
                    <h3>Event Sponsorship</h3>
                    <p>
                      Work with Bounce’s corporate partners for food, drinks,
                      and custom swag
                    </p>
                  </div>
                  <div className={styles.Feature}>
                    <img src="/img/icons/cohost.svg" alt="Feature" />
                    <h3>Co-hosts & Operators</h3>
                    <p>
                      Add other event organizers to help manage and run your
                      event
                    </p>
                  </div>
                </div>
              </div>
            </Carousel>
            <div className={styles.Arrows}>
              <div className={styles.Arrow}>
                <FontAwesomeIcon
                  style={{ pointer: 'cursor' }}
                  icon={faAngleLeft}
                  onClick={() => sliderDesktop.current.prev()}
                  size="2x"
                />
              </div>
              <div className={styles.Arrow}>
                <FontAwesomeIcon
                  icon={faAngleRight}
                  onClick={() => sliderDesktop.current.next()}
                  size="2x"
                />
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default FeatureCarousel;
